<i18n>
{
	"en": {
		"orderType": "Order Type",
		"selectOrderType": "Select order type"
	},
	"no": {
		"orderType": "Type Oppdrag",
		"selectOrderType": "Velg oppdragstype"
	}
}
</i18n>
<template>
	<t-form-group :title="$t('orderType')" rowGap="5px">
		<t-select
			:items="orderHasTrip ? orderTypesWithTripHandling : orderTypes"
			:selectedItem="selectedItem"
			:disabled="disabled || hasNoOrderTypes"
			width="100%"
			displayName="name"
			v-bind="$attrs"
			relative
			showPopoverOnFocus
			:enableFocusNextOnKeyboardSelect="enableFocusNextOnKeyboardSelect"

			@change="$emit('change', $event)"
			@select="$emit('select', $event)"
		>
			<template #displayedValue>
				{{
					selectedItem
						&& 'name' in selectedItem
						? selectedItem.name
						: $t('selectOrderType')
				}}
			</template>
		</t-select>
	</t-form-group>
</template>

<script>
import { mapState, mapActions } from './store/orderTypes.store';

export default {
	name: 'OrderTypesFormInput',
	inheritAttrs: false,
	props: {
		selectedItem: Object,
		disabled: {
			type: Boolean,
			default: false
		},
		orderHasTrip: Boolean,
		enableFocusNextOnKeyboardSelect: Boolean,
	},
	computed: {
		...mapState(['orderTypes']),
		hasNoOrderTypes() {
			return !this.orderTypes || this.orderTypes.length === 0;
		},
		orderTypesWithTripHandling() {
			return this.orderTypes
				.filter( type => type.tripHandling );
		}
	},
	mounted() {
		this.getOrderTypes();
	},
	methods: { ...mapActions(['getOrderTypes']) }
};

</script>

<style lang="scss" scoped>

</style>
